export enum AuthTypes {
  SIGNIN_SUCCESS = 'SIGNIN_SUCCESS',
  SET_TOKEN = 'SET_TOKEN',
  RESET_TOKEN = 'RESET_TOKEN',
  USER_LOGGED_OUT_TOKEN = 'USER_LOGGED_OUT_TOKEN',
  SIGNIN_ANONYMOUS = 'SIGNIN_ANONYMOUS',
  SIGNIN_ADMIN_SUCCESS = 'SIGNIN_ADMIN_SUCCESS',
}
